module.exports = "/_next/static/images/AA-e91bcb7da2116bd5dc5a1e05b15d0a5d.png";